import React, { useState, useEffect } from 'react'
import { Flex } from 'antd'

import { Carousel } from 'antd/lib'

import SliderStyled from 'src/pages/Aboutus/components/Slider/Slider'

import { equipNews } from './news'

import { AboutContainer, Title, InfoCard, Image, Link } from './styles'

const NewSection = () => {
  const [isPaused, setIsPaused] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 568)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <AboutContainer>
      <Title>Conoce más de Equip</Title>
      {isMobile ? (
        <Carousel autoplay>
          {equipNews.map((item) => (
            <InfoCard key={item.id}>
              <Flex vertical align="start" gap={40}>
                <Image src={item.image} alt="news" />
                <span style={{ textAlign: 'start' }}>{item.description}</span>
              </Flex>
              <Link href={item.link} target="_blank" style={{ marginBlockStart: '1.5rem' }}>
                Ir a enlace
                <img src="/icons/icon.svg" alt="icon" width={18} height={18}></img>
              </Link>
            </InfoCard>
          ))}
        </Carousel>
      ) : (
        <SliderStyled isPaused={isPaused}>
          {equipNews.map((item) => (
            <InfoCard
              key={item.id}
              onMouseEnter={() => setIsPaused(true)}
              onMouseLeave={() => setIsPaused(false)}
            >
              <Flex vertical align="start" gap={10}>
                <Image src={item.image} alt="news" />
                <span style={{ textAlign: 'start' }}>{item.description}</span>
              </Flex>
              <Link href={item.link} target="_blank">
                Ir a enlace
                <img src="/icons/icon.svg" alt="icon" width={18} height={18}></img>
              </Link>
            </InfoCard>
          ))}
        </SliderStyled>
      )}
    </AboutContainer>
  )
}

export default NewSection
